




























import { Action } from 'vuex-class'
import { Vue, Component, Prop } from 'vue-property-decorator'
import StoreAPI from '@/util/api/StoreAPI'
import { Maybe } from '@/types/general'
import { RootState } from '@/store/types'
import Entry from '@/data/entry-model'
import { FETCH_ENTRY } from '@/store/entries/constants'

@Component({ name: 'v-copy-unlock' })
export default class VCopyUnlock extends Vue {
    /**
     * Entry to track
     */
    @Prop({ type: Object, required: true })
    entry!: Entry

    /**
     * Icon style type
     */
    @Prop({ type: String, default: 'dark-to-primary' })
    type!: string

    /**
     * Icon container size
     */
    @Prop({ type: String, default: 'md' })
    containerSize!: string

    /**
     * At which theme to invert the icon
     */
    @Prop({ type: String })
    invert!: string

    /**
     * Force hydrate an entry if it isn't loaded yet
     */
    @Action(FETCH_ENTRY)
    fetchEntry!: (entryId: string) => Promise<Entry>

    /**
     * The unlocked password (if entry is loaded and not stale)
     */
    get password(): Maybe<string> {
        return this.entry.loaded() && !this.entry.pendingUpdate
            ? this.entry.fields.password : undefined
    }

    /**
     * Fetch the entry when it's not already loaded
     */
    async unlock(): Promise<void> {
        await this.fetchEntry(this.entry.id!)
        this.$success({ text: `Password unlocked for <strong>${this.entry.title}</strong>` })
    }

    /**
     * Way to programatically trigger unlock + copy
     */
    action(): void {
        ((this.$refs.action as Vue).$el as HTMLElement).click()
    }
}
